<cc-tool-tip
  [contentText]="propertyKindWarning"
  [placement]="['right', 'left']"
  *ngIf="!editable"
>
  <button
    type="button"
    class="property-kind-badge"
    readonly="true"
  >
    <em [class]="selectedKindIconClass"></em>
  </button>
</cc-tool-tip>

<cc-dropdown
  placement="bottom-left"
  size="lg"
  *ngIf="editable"
>
  <div
    class="property-kind-badge editable"
    #selectPropertyKindButton
    dropdownToggle
    title="Select property type"
  >
    <em [class]="selectedKindIconClass"></em>
    <em class="cc-icon cc-icon-arrow-down-small"></em>
  </div>

  <cc-dropdown-item
    (select)="selectKind(listEntryTypes.Text)"
    [attr.data-test]="'select-property-kind-' + listEntryTypes.Text"
    dropdownItem
  >
    <div class="property-dropdown-item">
      <i class="cc-icon cc-icon-text" aria-hidden="true"></i>
      <span>Text</span>
    </div>
  </cc-dropdown-item>

  <cc-dropdown-item
    (select)="selectKind(listEntryTypes.Number)"
    [attr.data-test]="'select-property-kind-' + listEntryTypes.Number"
    dropdownItem
  >
    <div class="property-dropdown-item">
      <i class="cc-icon cc-icon-number" aria-hidden="true"></i>
      <span>Number</span>
    </div>
  </cc-dropdown-item>

  <cc-dropdown-item
    (select)="selectKind(listEntryTypes.Date)"
    [attr.data-test]="'select-property-kind-' + listEntryTypes.Date"
    dropdownItem
  >
    <div class="property-dropdown-item">
      <i class="cc-icon cc-icon-calendar" aria-hidden="true"></i>
      <span>Date</span>
    </div>
  </cc-dropdown-item>

  <cc-dropdown-item
    (select)="selectKind(listEntryTypes.DateExpiry)"
    [attr.data-test]="'select-property-kind-' + listEntryTypes.DateExpiry"
    dropdownItem
  >
    <div class="property-dropdown-item">
      <i class="cc-icon cc-icon-calendar" aria-hidden="true"></i>
      <span>Date Expiry</span>
    </div>
  </cc-dropdown-item>

  <cc-dropdown-item
    (select)="selectKind(listEntryTypes.Attachment)"
    [attr.data-test]="'select-property-kind-' + listEntryTypes.Attachment"
    dropdownItem
  >
    <div class="property-dropdown-item">
      <i class="cc-icon cc-icon-attachment" aria-hidden="true"></i>
      <span>PDF Attachment</span>
    </div>
  </cc-dropdown-item>
</cc-dropdown>
